"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("./styles");
// Copied from components/icons
var Icon = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Icon.defaultProps = {
    width: '1em',
    height: '1em',
    viewBox: '0 0 32 32',
    fill: '#d8d8db',
};
var CheckboxIndeterminateIcon = function (props) { return (react_1.default.createElement(Icon, __assign({}, props, { viewBox: "0 0  24 24" }),
    react_1.default.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        react_1.default.createElement("path", { d: "M5,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,19 C20,19.5522847 19.5522847,20 19,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 Z M8,11 L8,13 L16,13 L16,11 L8,11 Z", fill: "#5CB247" })))); };
var CheckboxUncheckedIcon = function (props) { return (react_1.default.createElement(Icon, __assign({}, props, { viewBox: "0 0  24 24" }),
    react_1.default.createElement("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }),
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }))); };
var Checkbox = function (_a) {
    var checked = _a.checked, indeterminate = _a.indeterminate, onChange = _a.onChange, className = _a.className;
    return (react_1.default.createElement(styles_1.Wrapper, { className: className, onClick: onChange, role: "checkbox", tabIndex: 0, "aria-checked": checked },
        indeterminate ? react_1.default.createElement(CheckboxIndeterminateIcon, null) : null,
        !indeterminate && checked ? react_1.default.createElement(styles_1.StyledCheckboxCheckedIcon, null) : null,
        !indeterminate && !checked ? react_1.default.createElement(CheckboxUncheckedIcon, null) : null));
};
exports.default = Checkbox;
Checkbox.propTypes = {
    checked: prop_types_1.default.bool,
    indeterminate: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    className: prop_types_1.default.string,
};
Checkbox.defaultProps = {
    checked: false,
    indeterminate: false,
    onChange: function () { },
    className: '',
};
var templateObject_1;
//# sourceMappingURL=Checkbox.js.map